import { Injectable } from "@angular/core";

@Injectable()
export class EnumFilterService {
  public createEnumFilterArray<EnumType, FilterType>(enumType: EnumType, fieldName: string, omitValues: any[] | null = null): FilterType[] {
    const arr:  FilterType[] = [];
    for(const enumMember in enumType) {
      if (enumMember && isNaN(+enumMember)) {
        const enumValue = enumType[enumMember];
        if (omitValues?.find(v => v === enumValue) != null) {
          continue;
        }
        const obj: any = {};
        obj[fieldName] = enumValue;
        arr.push(obj);
      }
    }
    return arr;
  }
}
